import SelectPaymentTerminalDialog from '@/components/payments/orders/SelectPaymentTerminalDialog.vue'
import TerminalVendorEnum from '@/api/Enums/TerminalVendorEnum.js'
import {AES, HmacMD5} from '@/lib/crypto/crypto.js'

export default {
  components: {
    SelectPaymentTerminalDialog
  },

  mixins: [],

  data() {
    return {
      selectDeviceTerminalVisible: false
    }
  },

  computed: {
    TerminalVendorEnum() {
      return TerminalVendorEnum
    }
  },

  created() {

  },

  beforeDestroy() {

  },

  methods: {
    onSelectDeviceTerminal() {
      this.selectDeviceTerminalVisible = true
    },
    onSetActiveDeviceTerminal(terminal) {
      if (!terminal) return
      const key = HmacMD5.hash('ActiveDeviceTerminal')
      const payload = AES.encrypt({TerminalId: terminal.TerminalId, VendorCode: terminal.PosVendorCode})
      this.$localStorage.set(key, payload)
    }
  }
}
